import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const SectionPage = lazy(
  () => import('./SectionPage.eager').then(mod => ({default: mod.SectionPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
